@if (fetchingAuths || updatingAuths) {
<rs-loader></rs-loader>
}

<div class="auth-at-group-level">
    @if (errors) {
    <p class="error">{{errors}}</p>
    }
    @if (updatingAutherrors) {
    <p class="error">{{updatingAutherrors}}</p>
    }
    <!-- Auth options at client or subgroup level -->
    <div class="auth-options">
        @if (displayConvertToUserCheck) {
            <rs-checkbox color="secondary" id="convertToUser" name="convertToUser" label="Convert to user" value="convertToUser" (change)="displayConvertToUserCheck = false"></rs-checkbox>
        }
        <rs-notification type="info" [visible]="selectedOption === 'clientAllSubgroups'" message="Please keep in mind that the access noted below for ‘All subgroups’ may not be available for every subgroup. For example, as the administrator, you may have access to Billing Reports for subgroup A, but not for subgroup B. In this case, selecting Billing Reports for all subgroups will not provide this user with Billing Reports for subgroup B.  Your users will not receive a higher level of access than you when selecting this option."></rs-notification>

        @if (!displayConvertToUserCheck) {
            <rs-radio id="sub-radio-1" name="clientLevel" value="clientAllSubgroups" label="Select for all SubGroups" (change)="manageUserAuthFor($any($event.target).value)"></rs-radio>
            @if (userInfo().adminRole !== 'BMT-SUBGROUP-ADMIN') {
            <rs-radio id="sub-radio-2" name="clientLevel" value="customizeClientSubgroups" label="Select to customize SubGroups" (change)="manageUserAuthFor($any($event.target).value)"></rs-radio>
            }
            @if ((userInfo().adminRole === 'BMT-GROUP-ADMIN' || userInfo().adminRole === 'BMT-SUBGROUP-ADMIN') && userInfo().selectedUserType.toLowerCase() !== 'delegate') {
            <rs-radio id="sub-radio-3" name="clientLevel" value="delegate" label="Create Delegate - a user who can create users and manage authorizations on your behalf" (change)="manageUserAuthFor($any($event.target).value)"></rs-radio>
            }
            <rs-radio id="sub-radio-4" name="clientLevel" value="revokeAtClient" label="Revoke authorizations for the group" (change)="manageUserAuthFor($any($event.target).value)"></rs-radio>
        }
    </div>
    <!-- Table to modify auths at allsubgroups or customize subgroups -->
    @if (!fetchingAuths && selectedOption && selectedOption !== 'revokeAtClient' && selectedOption !== 'delegate' && !errors && userAndAdminAuths.userRelatedAuthorizations.length && editAllSubGroupsForm) {
    <div class="sub-group-auths">
            <form [formGroup]="editAllSubGroupsForm">
                <table>
                    <thead>
                        @if (selectedOption === 'customizeClientSubgroups') {
                        <th>
                            <rs-checkbox id="selectAllSubGroups" checked="false" formControlName="selectAllSubGroups" (change)="syncSelectAllSubGroups()"></rs-checkbox>
                        </th>
                        }
                        <th>Subgroup ID</th>
                        <th>Subgroup Name</th>
                        @if (userAndAdminAuths.adminRelatedAuthorizations.eligibilityAccessLevel) {
                        <th>
                            <span>Eligibility Access</span>
                            <rs-select [attr.role]="'combobox'" id="adminEligAccess" aria-expanded="false" formControlName="adminEligAccess" [items]="eligAccessLevelOptions" (change)="syncAdminValue('adminEligAccess', 'userEligAccess', true)"></rs-select>
                        </th>
                        }
                        @if (userAndAdminAuths.adminRelatedAuthorizations.clientKnowledgeIndicator) {
                        <th>
                            <span>Client Knowledge</span>
                            <rs-checkbox id="adminClientKnowledge" formControlName="adminClientKnowledge" (change)="syncAdminValue('adminClientKnowledge', 'userClientKnowledge')"></rs-checkbox>
                        </th>
                        }
                        @if (userAndAdminAuths.adminRelatedAuthorizations.customClientReportAccessIndicator) {
                        <th>
                          <span>Custom Client Reports</span>
                          <rs-checkbox id="adminCustomClientReport" formControlName="adminCustomClientReport" (change)="syncAdminValue('adminCustomClientReport', 'userCustomClientReportAccess')"></rs-checkbox>
                        </th>
                        }
                        @if (userAndAdminAuths.adminRelatedAuthorizations.billingReportAccessIndicator) {
                        <th>
                            <span>Billing Report</span>
                            <rs-checkbox id="adminBillingReport" formControlName="adminBillingReport" (change)="syncAdminValue('adminBillingReport', 'userBillingReport')"></rs-checkbox>
                        </th>
                        }
                        @if (userAndAdminAuths.adminRelatedAuthorizations.claimDetailReportAccessIndicator) {
                        <th>
                            <span>Claim Detail Report</span>
                            <rs-checkbox id="adminClientDetailReport" formControlName="adminClientDetailReport" (change)="syncAdminValue('adminClientDetailReport', 'userClientDetailReport')"></rs-checkbox>
                        </th>
                        }
                        @if (userAndAdminAuths.adminRelatedAuthorizations.satAccessLevel) {
                        <th>
                            <span>Sat Access Level</span>
                            <rs-select [attr.role]="'combobox'" aria-expanded="false" id="adminSatAccess" formControlName="adminSatAccess" [items]="satAccessLevelOptions" (change)="syncAdminValue('adminSatAccess', 'userSatAccess', true)"></rs-select>
                        </th>
                        }
                    </thead>
                    <tbody>
                        @for (user of userAndAdminAuths.userRelatedAuthorizations; track user.subGroupSpecifiedIdentifier; let i = $index) {
                        <tr>
                            <!-- Below is the form to manage auth for custom subgroups -->
                            <ng-container formArrayName="userAuthForm">
                                @if (selectedOption === 'customizeClientSubgroups') {
                                <ng-container [formGroupName]="i">
                                    <td>
                                        <rs-checkbox [id]="user.subGroupSpecifiedIdentifier" formControlName="userPrivilege" (change)="refreshCustomSubGroupDirtyState()"></rs-checkbox>
                                    </td>
                                    <td>{{user.subGroupSpecifiedIdentifier}}</td>
                                    <td>{{user.subGroupName}}</td>
                                    @if (userAndAdminAuths.adminRelatedAuthorizations.eligibilityAccessLevel) {
                                    <td>
                                        @if (adminSubGroupAuths[user.subGroupSpecifiedIdentifier].eligibilityAccessLevel && adminSubGroupAuths[user.subGroupSpecifiedIdentifier].eligibilityAccessLevel.toLowerCase() !== 'none') {
                                            <rs-select [id]="user.subGroupSpecifiedIdentifier+'userEligAccess'" formControlName="userEligAccess" [items]="adminSubGroupAuths[user.subGroupSpecifiedIdentifier].eligibilityAccessLevel.toLowerCase() === 'inquiry' ? inquiryOptions : adminSubGroupAuths[user.subGroupSpecifiedIdentifier].eligibilityAccessLevel.toLowerCase() === 'None' ? noneOptions : updateOptions" [attr.role]="'combobox'" aria-expanded="false" (change)="refreshCustomSubGroupDirtyState()"></rs-select>
                                        }
                                    </td>
                                    }
                                    @if (userAndAdminAuths.adminRelatedAuthorizations.clientKnowledgeIndicator) {
                                    <td>
                                        @if (adminSubGroupAuths[user.subGroupSpecifiedIdentifier].clientKnowledgeIndicator) {
                                            <rs-checkbox formControlName="userClientKnowledge" [id]="user.subGroupSpecifiedIdentifier+'userClientKnowledge'" (change)="refreshCustomSubGroupDirtyState()"></rs-checkbox>
                                        }
                                    </td>
                                    }
                                    @if (userAndAdminAuths.adminRelatedAuthorizations.customClientReportAccessIndicator) {
                                  <td>
                                    @if (adminSubGroupAuths[user.subGroupSpecifiedIdentifier].customClientReportAccessIndicator) {
                                      <rs-checkbox formControlName="userCustomClientReportAccess" [id]="user.subGroupSpecifiedIdentifier+'userCustomClientReportAccess'" (change)="refreshCustomSubGroupDirtyState()"></rs-checkbox>
                                    }
                                  </td>
                                    }
                                    @if (userAndAdminAuths.adminRelatedAuthorizations.billingReportAccessIndicator) {
                                    <td>
                                        @if (adminSubGroupAuths[user.subGroupSpecifiedIdentifier].billingReportAccessIndicator) {
                                            <rs-checkbox formControlName="userBillingReport" [id]="user.subGroupSpecifiedIdentifier+'userBillingReport'" (change)="refreshCustomSubGroupDirtyState()"></rs-checkbox>
                                        }
                                    </td>
                                    }
                                    @if (userAndAdminAuths.adminRelatedAuthorizations.claimDetailReportAccessIndicator) {
                                    <td>
                                        @if (adminSubGroupAuths[user.subGroupSpecifiedIdentifier].claimDetailReportAccessIndicator) {
                                            <rs-checkbox formControlName="userClientDetailReport" [id]="user.subGroupSpecifiedIdentifier+'userClientDetailReport'" (change)="refreshCustomSubGroupDirtyState()"></rs-checkbox>
                                        }
                                    </td>
                                    }
                                    @if (userAndAdminAuths.adminRelatedAuthorizations.satAccessLevel) {
                                    <td>
                                        @if (adminSubGroupAuths[user.subGroupSpecifiedIdentifier].satAccessLevel && adminSubGroupAuths[user.subGroupSpecifiedIdentifier].satAccessLevel.toLowerCase() !== 'none') {
                                            <rs-select formControlName="userSatAccess" [attr.role]="'combobox'" aria-expanded="false" [id]="user.subGroupSpecifiedIdentifier+'userSatAccess'" [items]="adminSubGroupAuths[user.subGroupSpecifiedIdentifier].satAccessLevel.toLowerCase() === 'inquiry' ? inquiryOptions : adminSubGroupAuths[user.subGroupSpecifiedIdentifier].satAccessLevel.toLowerCase() === 'None' ? noneOptions : updateOptions" (change)="refreshCustomSubGroupDirtyState()"></rs-select>
                                        }
                                    </td>
                                    }
                                </ng-container>
                                }
                            </ng-container>
                            <!-- Below is the form to manage auth for all subgroups -->
                            @if (selectedOption === 'clientAllSubgroups') {
                            <ng-container formGroupName="userAuthForm">
                                <td>All</td>
                                <td>All SubGroups</td>
                                @if (userAndAdminAuths.adminRelatedAuthorizations.eligibilityAccessLevel) {
                                <td>
                                    <rs-select aria-expanded="false" [attr.role]="'combobox'" formControlName="userEligAccess" id="userEligAccess" [items]="eligAccessLevelOptions" (change)="refreshAllSubGroupDirtyState()"></rs-select>
                                </td>
                                }
                                @if (userAndAdminAuths.adminRelatedAuthorizations.clientKnowledgeIndicator) {
                                <td>
                                    <rs-checkbox formControlName="userClientKnowledge" id="userClientKnowledge" (change)="refreshAllSubGroupDirtyState()"></rs-checkbox>
                                </td>
                                }
                                @if (userAndAdminAuths.adminRelatedAuthorizations.customClientReportAccessIndicator) {
                                <td>
                                  <rs-checkbox formControlName="userCustomClientReportAccess" id="userCustomClientReportAccess" (change)="refreshAllSubGroupDirtyState()"></rs-checkbox>
                                </td>
                                }
                                @if (userAndAdminAuths.adminRelatedAuthorizations.billingReportAccessIndicator) {
                                <td>
                                    <rs-checkbox formControlName="userBillingReport" id="userBillingReport" (change)="refreshAllSubGroupDirtyState()"></rs-checkbox>
                                </td>
                                }
                                @if (userAndAdminAuths.adminRelatedAuthorizations.claimDetailReportAccessIndicator) {
                                <td>
                                    <rs-checkbox formControlName="userClientDetailReport" id="userClientDetailReport" (change)="refreshAllSubGroupDirtyState()"></rs-checkbox>
                                </td>
                                }
                                @if (userAndAdminAuths.adminRelatedAuthorizations.satAccessLevel) {
                                <td>
                                    <rs-select formControlName="userSatAccess" id="userSatAccess" [attr.role]="'combobox'" aria-expanded="false" [items]="satAccessLevelOptions" (change)="refreshAllSubGroupDirtyState()"></rs-select>
                                </td>
                                }
                            </ng-container>
                            }
                        </tr>
                        }
                    </tbody>
                </table>
            </form>
    </div>
    }
    @if (selectedOption === 'customizeClientSubgroups' && !errors) {
    <rs-paginator [length]="totalAuths"
                    (page)="getMoreAuths($event)" showFirstLastButtons
                    [pageSize]="defaultPageSize"></rs-paginator>
    }
    <!-- Buttons Contianer to save/revoke the auths -->
    <div class="btns-cont">
        <button rs-raised-button class="next-btn" [disabled]="!selectedOption || (selectedOption === 'customizeClientSubgroups' && !formChangesDetecedForCustomEdit) || (selectedOption === 'clientAllSubgroups' && !authsModifiedForAllSubGroups)" color="primary" (click)="manageAuthorizations()">Save</button>
        <button rs-raised-button color="secondary" (click)="cancelGroupAuthEdit.emit(true)">Cancel</button>
    </div>

</div>
<!-- Confirmation pop up -->
<rs-dialog [visible]="showUpdateDialog && !!(selectedOption && updatingAuthsResp && !updatingAuths)" heading="User Authorizations" maxWidth="60%" class="bmt-manager-user-auth" (visibleChange)="handleUpdateDialogVisibility($event)">
    <div style="padding: 20px;">
        @if (selectedOption !== 'customizeClientSubgroups') {
           <p>
               {{selectedOption === 'revokeAtClient' ? 'Authorizations for this group are revoked' : 'User authorizations are updated'}}
           </p>
           <div style="justify-content: space-between;display: flex;">
               <button style="width: auto;" rs-raised-button color="secondary" (click)="navigateToUserAdmin('viewAuth')">View authorizations</button>
               <button style="width: auto;" rs-raised-button color="secondary" (click)="navigateToUserAdmin('manage')">Manage other User</button>
           </div>
        }
        @if (selectedOption === 'customizeClientSubgroups') {
            <p class="success-msg">
                Authorizations for the subgroups selected are saved{{totalAuths > 100 ? ', proceed for next set.': '.'}}
            </p>
            <div style="justify-content: space-between;display: flex;">
                <button style="width: auto;" rs-raised-button color="secondary" (click)="navigateToUserAdmin('viewAuth')">View authorizations</button>
                <button style="width: auto;" rs-raised-button color="secondary" (click)="navigateToUserAdmin('close')">Close</button>
            </div>
        }
    </div>
</rs-dialog>
